<template>
  <Dialog
    :visible.sync="show"
    :style="{ width: $isMobile() ? '100vw' : '50vw', position: 'relative' }"
    :class="[{ 'p-dialog-maximized': $isMobile() }]"
    :modal="true"
    :closable="false"
    header="Adicionar Ficheiros à Compra"
  >
    <Loading :active.sync="loading" :isFullPage="false" :zIndex="9000" />

    <AppFileUpload
      ref="fileUpload"
      mode="advanced"
      name="files[]"
      chooseLabel="Escolher Ficheiros"
      accept=".pdf,.jpg,.jpeg,.png,.webp"
      :maxFileSize="10485760"
      :multiple="true"
      :showUploadButton="false"
      :showCancelButton="false"
      :previewWidth="200"
      @select="onFilesSelect"
      @remove="syncSelectedFiles"
    >
      <template #fileContent="{ file, index }">
        <div class="file-description-wrapper">
          <span class="p-float-label">
            <InputText
              :id="`purchase-file-description-${index}`"
              v-model="getFileEntry(file).description"
              :maxlength="100"
              :class="{ 'p-invalid': getFileEntry(file).descriptionError }"
              @input="getFileEntry(file).descriptionError = false"
            />
            <label :for="`purchase-file-description-${index}`">Descrição *</label>
          </span>
          <small v-if="getFileEntry(file).descriptionError" class="p-error">
            Descrição é obrigatória
          </small>
        </div>
      </template>
    </AppFileUpload>

    <template #footer>
      <Button
        type="button"
        :label="selectedFiles.length ? `Guardar (${selectedFiles.length})` : 'Guardar'"
        icon="pi pi-save"
        class="p-button-success"
        :disabled="loading || !selectedFiles.length"
        @click="saveFiles"
      />
      <Button
        type="button"
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-danger"
        :disabled="loading"
        @click="close"
      />
    </template>
  </Dialog>
</template>

<script>
import Loading from "vue-loading-overlay";
import AppFileUpload from "@/components/elements/AppFileUpload.vue";
import purchaseService from "@/services/purchase.service";

export default {
  name: "AddPurchaseFiles",
  components: { Loading, AppFileUpload },
  props: {
    show: { type: Boolean, required: true },
    stamp: { type: String, default: null },
    stageOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      selectedFiles: [],
    };
  },
  watch: {
    show(value) {
      if (!value) this.reset();
    },
  },
  methods: {
    getFileEntry(file) {
      let entry = this.selectedFiles.find(
        item => item.file.name === file.name && item.file.size === file.size
      );
      if (!entry) {
        entry = { file, description: file.name, descriptionError: false };
        this.selectedFiles.push(entry);
      }
      return entry;
    },
    onFilesSelect(event) {
      event.files.forEach(file => this.getFileEntry(file));
    },
    syncSelectedFiles() {
      const files = this.$refs.fileUpload ? this.$refs.fileUpload.files : [];
      this.selectedFiles = this.selectedFiles.filter(entry =>
        files.some(file => file.name === entry.file.name && file.size === entry.file.size)
      );
    },
    validate() {
      let valid = true;
      this.selectedFiles.forEach(entry => {
        entry.descriptionError = !entry.description || !entry.description.trim();
        valid = valid && !entry.descriptionError;
      });
      this.$forceUpdate();
      return valid;
    },
    async saveFiles() {
      if (!this.validate()) return;

      if (this.stageOnly) {
        this.$emit("staged", this.selectedFiles.map(entry => ({
          file: entry.file,
          description: entry.description.trim(),
        })));
        this.close();
        return;
      }

      this.loading = true;
      try {
        await Promise.all(this.selectedFiles.map(entry => {
          const formData = new FormData();
          formData.append("file", entry.file);
          formData.append("resume", entry.description.trim());
          return purchaseService.uploadPurchaseFile(this.stamp, formData);
        }));
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: `${this.selectedFiles.length} ficheiro(s) guardado(s) com sucesso.`,
          life: 3000,
        });
        this.$emit("added");
        this.close();
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível guardar todos os ficheiros.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.selectedFiles = [];
      if (this.$refs.fileUpload) this.$refs.fileUpload.clear();
    },
    close() {
      this.reset();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.file-description-wrapper {
  width: 100%;
  margin-top: 0.75rem;
}
</style>
